import { useMemo } from "react";
import { PolicyPagesEnum } from "@finbackoffice/fe-core";
import { useRuntimeConfig } from "./useRuntimeConfig";

export const usePoliciesPagesConfig = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");

    const enabledPoliciesConfig = useMemo(
        () => COMMON_SITE_CONFIGS._policies.filter((config) => config.enable),
        [COMMON_SITE_CONFIGS._policies],
    );

    const enabledPolicySportsbookConfig = useMemo(
        () =>
            COMMON_SITE_CONFIGS._policies
                .find((config) => config.name === PolicyPagesEnum.Sports)
                ?.config?.filter((config) => config.enable),
        [COMMON_SITE_CONFIGS._policies],
    );

    return { enabledPoliciesConfig, enabledPolicySportsbookConfig };
};
